import { decryptHandler, encryptHandler } from '../../config/encryptDecrypt';
import * as types from '../types';

const decrypted = JSON.parse(localStorage.getItem('userDetails') || '{}');
const decryptedInfo = decrypted && decryptHandler(decrypted)

  const initialState = {
    error: false,
    success: false,
    userDetail: decryptedInfo && JSON.parse(decryptedInfo),
    fetching: false,
  };
  
  const userApplicationReducer = (state = initialState, action:any) => {
    const { type, payload } = action;
    
    switch (type) {
      case types.GET_USERDETAILS_BEGIN:
        return {
          ...state,
          userResponse: null,
          error: null,
          success: false,
          fetching: true,
        };

      case types.GET_USERDETAILS_SUCCESS:
        const encryted = encryptHandler(payload)
        localStorage.setItem("userDetails", JSON.stringify(encryted));
        return {
          ...state,
            userDetail: payload,
            error: false,
            success: true,
            fetching: false,
        };

      case types.GET_USERDETAILS_FAILURE:
        return {
          ...state,
          userDetail: null,
          success: false,
          error: true,
          fetching: false,
        };
        case types.GET_USERDETAILS_RESET:
        return {
            ...state,
        };
      default:
        return state;
    }
  }

  export default userApplicationReducer;